// THE EMAILS PAGE BEFORE AN ACCOUNT IS CONNECTED (Fatemeh's connect-email design, Figma
// 40011420:278006 — busy-my-web#451; her answer in the Slack thread pins the surface: "when the
// user enters the Emails page and has not connected their email yet").
//
// Two halves, one set of words, so the page and the box cannot drift apart:
//   - the PAGE's own centred state — "Connect Gmail to Busy", what Busy will do with the mailbox,
//     the "Connect Google account" button and the reassurance under it;
//   - the BOX's briefing card — "Briefing · Email" over "Connect your email to get started".
//
// Both are plain data here, and the card is built through the shared `briefing()` shape so the
// strip renders it exactly as it renders every other card.

import { briefing } from './rows'

/** The card's identity on the strip. Not `emails` — that is the inbox SESSION's card. */
export const CONNECT_KIND = 'email-connect'

/** Every word either half says, in the frame's spelling. */
export const CONNECT_TEXT = {
  // The page (centre of the listing column).
  heading: 'Connect Gmail to Busy',
  blurb: 'Busy will securely read your email to understand conversations, find what needs attention, and connect relevant information to your Ongoings.',
  button: 'Connect Google account',
  reassurance: 'You can disconnect your account at any time.',
  // The box.
  cardTitle: 'Briefing · Email',
  cardHeadline: 'Connect your email to get started',
  cardNote: 'Once connected, Busy will brief you on what needs attention and help connect relevant emails to your Ongoings.',
}

/**
 * busy-ids#13 — the page's words when Google WAS connected but its grant has since been revoked
 * or expired (the BFF's `needsReconnect`). Same shape and button as CONNECT_TEXT, so the gate keeps
 * Fatemeh's layout; only the wording says why the mailbox stopped.
 */
export const RECONNECT_TEXT = {
  ...CONNECT_TEXT,
  heading: 'Reconnect Gmail to Busy',
  blurb: 'Google access expired or was revoked — reconnect to resume syncing your email.',
  button: 'Reconnect Google',
}

/** The SmartBox card the frame draws under the page. */
export function emailConnectBriefing() {
  return briefing({
    kind: CONNECT_KIND,
    title: CONNECT_TEXT.cardTitle,
    titleIcon: 'sms',
    titleColor: '#111827',
    subtitle: CONNECT_TEXT.cardHeadline,
    note: CONNECT_TEXT.cardNote,
  })
}

export default emailConnectBriefing
